import { render, staticRenderFns } from "./LinkBuilder.vue?vue&type=template&id=42a23094&scoped=true"
import script from "./LinkBuilder.vue?vue&type=script&lang=js"
export * from "./LinkBuilder.vue?vue&type=script&lang=js"
import style0 from "./LinkBuilder.vue?vue&type=style&index=0&id=42a23094&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a23094",
  null
  
)

export default component.exports